import type { RouteLocationNormalizedLoaded } from 'vue-router'

type KeyedRoute = Pick<RouteLocationNormalizedLoaded, 'name' | 'params'>

// The page remounts when this changes; app.vue passes it to <NuxtPage>.
export function pageKey(route: KeyedRoute): string {
    return String(route.name) + (route.params.id || route.params.channelId || '')
}
